<div *ngIf="loading" class="text-center">
  <p-progressSpinner></p-progressSpinner>
</div>

<form *ngIf="!loading" [formGroup]="form" class="validated-form">
  <mojo-smtp-settings-viewer *ngIf="isSmtp()" [form]="form"></mojo-smtp-settings-viewer>
  <mojo-ms-oauth-settings-viewer *ngIf="isMsOauth()" [form]="form"></mojo-ms-oauth-settings-viewer>

  <div class="field grid">
    <label class="col-fixed">Test email recipient</label>
    <div class="col-fixed inputfield">
      <input class="form-control" type="text" pInputText id="testEmailRecipient" formControlName="testEmailRecipient" />
    </div>
  </div>

  <div class="field grid">
    <label class="col-fixed"></label>
    <div class="col">
      <button pButton pRipple
              [disabled]="cannotSendTestEmail() | async"
              label="Send test email"
              class="p-button-text"
              (click)="sendEmail()"></button>
    </div>
  </div>

</form>
